<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showEditLeavePeriod"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="editLeavePeriod"
          class="fixed max-h-screen center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div
            class="flex justify-between items-center bg-white sticky top-0 border-b-1.5 p-3"
          >
            <p class="text-base">Edit Time off Period</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              alt=""
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="edit_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ edit_error }}
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="edit_success"
              class="p-1 text-center text-sm w-full bg-green-200"
            >
              {{ edit_success }}
            </div>
          </transition>
          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Period Name</label>
              <input
                v-model="leavePeriodToEdit.PeriodName"
                required
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1">Starting Date</label>
              <input
                v-model="leavePeriodToEdit.StartingDate"
                required
                type="date"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>
{{ leavePeriodToEdit.EndingDate }}
            <div class="text-sm">
              <label class="block pb-1">Ending Date</label>
              <input
                v-model="formattedEndingDate"
                required
                type="date"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1">Opening January Date</label>
              <input
                v-model="leavePeriodToEdit.OpeningJanuaryDate"
                required
                type="date"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1">Closing December Date</label>
              <input
                v-model="leavePeriodToEdit.ClosingDecemberDate"
                required
                type="date"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>
          </div>
          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
import { africanCountries } from "@/utils/utilsData";
export default {
  name: "CompanySetupEditleavePeriod",
  props: ["showEditLeavePeriod", "leavePeriodToEdit", "reload"],
  components: { Loader },
  data() {
    return {
      managerId: "",
      saved_locations: [],
      employees: [],

      edit_error: null,
      edit_success: null,
      loading: false,
      formattedEndingDate:""
    };
  },
  created() {
    //console.log(this.leavePeriodToEdit)
    // this.getlocations();
    // //console.log(this.employees);
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },


  mounted() {
  this.formattedEndingDate = this.formatDate(this.leavePeriodToEdit.EndingDate);
},
methods: {
  formatDate(date) {
    if(date){
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;}else{
     return "";
    }
  },

    close() {
      this.$emit("close");
    },

    async fetchCountries(queryString, callback) {
      // fetch locations
      // based on the user input and call the callback function
      // with the resulting suggestions
      if (queryString) {
        this.country = africanCountries.filter((country) =>
          country.Name.toLowerCase().includes(queryString.toLowerCase())
        );
        //console.log(this.country)
        if (queryString && !this.country.length) {
          callback([{ Name: "No results found", Country: "No results found" }]);
          return;
        }
        callback(this.country);
      } else {
        callback(africanCountries);
      }
    },

    setCountryName(country) {
      this.leavePeriodToEdit.Country = country.Name;
    },

    editLeavePeriod() {
      this.loading = true;
      //console.log(this.leavePeriodToEdit)
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      axios
        .put(
          `${this.getOrganization}/setup/location/${this.$ApiVersion}/edit`,
          JSON.stringify(this.leavePeriodToEdit),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.edit_success = response.data.StatusMessage;
              setTimeout(() => {
                this.edit_success = null;
                this.close();
                this.reload();
              }, 3000);
            } else {
              this.edit_error = response.data.StatusMessage;
              setTimeout(() => {
                this.edit_error = null;
              }, 3000);
            }
          },
          (error) => {
            this.loading = false;
            this.edit_error = error.message;
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
